// タブのトグル処理を提供する
document.addEventListener('turbolinks:load', () => {
  const tabContainers = document.querySelectorAll('[data-tab-group]');
  if (!tabContainers) return;

  for (let i = 0; i < tabContainers.length; i += 1) {
    const tabContainer = tabContainers[i];
    const toggleElements = tabContainer.querySelectorAll('[data-tab-toggle]');

    for (let j = 0; j < toggleElements.length; j += 1) {
      const toggleElement = toggleElements[j];
      const targetTab = document.querySelector(toggleElement.getAttribute('data-tab-toggle'));

      toggleElement.addEventListener('click', () => {
        for (let k = 0; k < toggleElements.length; k += 1) {
          toggleElements[k].classList.remove('active');
          document.querySelector(toggleElements[k].getAttribute('data-tab-toggle')).classList.remove('active');
        }

        toggleElement.classList.add('active');
        targetTab.classList.add('active');
      });
    }
  }
});
